<template>
  <div>
    <el-group-title title="合同财务信息">
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="163px"
          class="ccui-form demo-form-inline ccui-form-detail"
          :inline="true"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="所在省/国家：" prop="province">
                <div>{{ form.province }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所在市/城市：" prop="city">
                <div>{{ form.city }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="所在县：" prop="county">
                <div>{{ form.county }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所在区域：" prop="deliverPlace">
                <div>{{ form.deliverPlace }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="计税方法编码：" prop="taxMethodCode">
                <div>{{ form.taxMethodCode }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="计税方法：" prop="taxMethod">
                <div>{{ form.taxMethod }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="发票类型编码：" prop="invoiceTypeCode">
                <div>{{ form.invoiceTypeCode }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="发票类型：" prop="invoiceType">
                <div>{{ form.invoiceType }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="合同份数/协议份数：" prop="contractNum">
                <div>{{ form.contractNum }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="物资来源：" prop="materialSource">
                <div>{{ form.materialSource }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="物资来源编码：" prop="materialSourceCode">
                <div>{{ form.materialSourceCode }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="支付系数：" prop="payTheCoefficient">
                <div>{{ form.payTheCoefficient }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="预付款：" prop="prepayment">
                <div>{{ form.prepayment }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="业务类型：" prop="businessType">
                <div>{{ form.businessType | businessType }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="签订地点：" prop="signPlace">
                <div>{{ form.signPlace }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
export default {
  name: "finance",
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        id: "",
        contractMaterialsId: "",
        province: "",
        city: "",
        county: "",
        deliverPlace: "",
        taxMethodCode: "",
        taxMethod: "",
        invoiceTypeCode: "",
        invoiceType: "",
        contractNum: "",
        materialSource: "",
        materialSourceCode: "",
        payTheCoefficient: "",
        prepayment: "",
        partyBId: "",
        businessType: "",
        signPlace: ""
      },
      rules: {}
    };
  },
  filters: {
    businessType(value) {
      const businessType = {
        "01": "物资",
        "02": "周转材",
        "03": "分包合同"
      };
      return businessType[value];
    }
  },
  watch: {
    dataInfo() {
      this.form = this.dataInfo;
    }
  }
};
</script>
